import { render, staticRenderFns } from "./business-daily.vue?vue&type=template&id=5a0f673c&scoped=true&"
import script from "./business-daily.vue?vue&type=script&lang=js&"
export * from "./business-daily.vue?vue&type=script&lang=js&"
import style0 from "./business-daily.vue?vue&type=style&index=0&id=5a0f673c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f673c",
  null
  
)

export default component.exports